import {Component, OnInit, Inject} from '@angular/core';
import { ErrorStateMatcher} from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import {Ordered} from 'src/app/models/ordered';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {OrderedService} from 'src/app/services/ordered.service';
import {FormGroup, FormControl, FormBuilder, FormGroupDirective, NgForm} from '@angular/forms';
import {SlotService} from 'src/app/services/slot.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-ordered-viewer-dialog',
  templateUrl: './ordered-viewer-dialog.component.html',
  styleUrls: [ './ordered-viewer-dialog.component.scss' ]
})
export class OrderedViewerDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();

  public ordered: Ordered = new Ordered()
  public new_order: boolean = false;
  public order_date: any;
  public local_title: any = ""

  public payment_type_display: string;
  public valor_liquido: any;
  public tax: number = 0;

  public entityForm: FormGroup;

  public dt_refunded: any;

  public new_order_inserted: boolean = false;

  constructor (
    private _slotService: SlotService,
    private fb: FormBuilder,
    private snackBar: SnackBarIconService,
    private dialog: MatDialog,
    public _orderedService: OrderedService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.ordered = this.data.ordered;
  }

  ngOnInit () {

    this.entityForm = this.createForm()
    this.setFormValues(this.ordered, this.entityForm)

    this.new_order = this.data.new_order

    this.order_date = this.ordered.date
    if (this.order_date.seconds) {
      this.order_date = new Date(this.order_date.seconds * 1000)
      this.local_title = ""
    } else {
      this.order_date = this.ordered.date
      this.local_title = "Confirmação - "
    }

    if (this.data.ordered.payment_type == "cartao" || this.data.ordered.payment_type == "CreditCard") {

      this.payment_type_display = "Cartão de Crédito"

      if (this.data.ordered.card_installments == 1) {
        this.tax = 0.037
      } else {
        this.tax = 0.047
      }
    } else if (this.data.ordered.payment_type == "Billet") {

      this.payment_type_display = "Boleto Bancário"

    } else if (this.data.ordered.payment_type == "Free") {

      this.payment_type_display = "Cortesia"
      this.tax = 0

    } else if (this.data.ordered.payment_type == "Cash") {

      this.payment_type_display = "Dinheiro"
      this.tax = 0

    }

    let debit = Number(this.data.ordered.member_debit)
    let value = Number(this.data.ordered.value)

    let tax_value = this.tax * (debit + value)
    this.valor_liquido = this.data.ordered.total - tax_value

    if (this.data.ordered.refund_date) {
      this.dt_refunded = new Date(this.data.ordered.refund_date.seconds * 1000)
    } else {
      this.dt_refunded = null
    }



  }

  createForm () {
    let form: FormGroup = this.fb.group({
      Tid: new FormControl(''),
      value: new FormControl(''),
      discount: new FormControl(''),
      debit: new FormControl(''),
      tax: new FormControl(''),
      total: new FormControl(''),
      total_minus_tax: new FormControl('')
    });

    return form
  }

  setFormValues (data, form) {
    form.controls.Tid.setValue(data.Tid);
    form.controls.value.setValue(data.value || 0);
    form.controls.discount.setValue(data.discount || 0);
    form.controls.debit.setValue(data.debit || 0);
    form.controls.tax.setValue(data.tax || 0);
    form.controls.total.setValue(data.total || 0);
    form.controls.total_minus_tax.setValue(data.total_minus_tax || 0);
  }

  updateOrder () {
    this._orderedService.spinner = true;

    /*
    console.log("id: " + this.ordered.id)
    console.log("TID: " + this.entityForm.controls.Tid.value)
    console.log("value: " + this.entityForm.controls.value.value)
    console.log("total: " + this.entityForm.controls.total.value)
    console.log("discount: " + this.entityForm.controls.discount.value)
    console.log("tax: " + this.entityForm.controls.tax.value)
    console.log("total_minus_tax: " + this.entityForm.controls.total_minus_tax.value)
    */


    this._orderedService.updateOrder(this.ordered.id, {
      'Tid': this.entityForm.controls.Tid.value || "",
      'value': this.entityForm.controls.value.value,
      'total': this.entityForm.controls.value.value,
      'discount': this.entityForm.controls.discount.value,
      'tax': this.entityForm.controls.tax.value,
      'total_minus_tax': this.entityForm.controls.total_minus_tax.value
    })
      .then((e) => {
        console.log("success")
        this.new_order_inserted = true;
        this.snackBar.openSnackBar("Sucesso!", '', 'success')
      })
      .catch((error) => {
        console.log("error insert ordered")
        this.snackBar.openSnackBar("Erro!", '', 'error')
      })
      .finally(() => {
        this._orderedService.spinner = false;
      })



  }

  delete (element) {

    const product_id = element.product_id
    const topic_id = element.topic_id

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.product_name + "<br><br>" + element.member_name + "<br><br>Excluir esta inscrição?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

      /*
      console.log('element.id: ' + element.id)
      console.log('element.member_name: ' + element.member_name)
      console.log('product_id: ' + product_id)
      console.log('topic_id: ' + topic_id)
      */
      
        this._orderedService.delete(element.id)
          .then(
            () => {
              // this._slotService.updateSlotQtd(product_id, topic_id, false) //false = -, true = +
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete order error: " + error.message)}
          )
            
      }          
    })
      
  }

  calcValue () {
    //console.log("calcValue")

    let value = this.entityForm.controls.value.value;
    let discount = this.entityForm.controls.discount.value;
    let tax = this.entityForm.controls.tax.value;
    let total_minus_tax = this.entityForm.controls.total_minus_tax.value;
    let subtotal: number = 0;
    let taxValue: number = 0;

    // console.log("value: " + value);
    // console.log("discount: " + discount);
    // console.log("tax: " + tax);
    // console.log("total_minus_tax: " + total_minus_tax);

    if (value) {
      subtotal = value
      if (discount) {
        subtotal = value - discount
      }
      if (this.ordered.payment_type == 'Billet') {
        subtotal = subtotal - 3.5
      } else {
        if (tax) {
          taxValue = subtotal * tax
          subtotal = subtotal - taxValue
        }
      }

      this.entityForm.controls.total_minus_tax.setValue(subtotal);

    }

  }

}

